import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-thong-so-moi-truong',
  templateUrl: './thong-so-moi-truong.component.html',
})
export class ThongSoMoiTruongComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
